import { Injector, runInInjectionContext } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState } from '@ngrx/signals';
import { tap } from 'rxjs';
import { GetProvinciaGQL } from '../../_graphql/generated';

export const getProvincia =
  (injector: Injector, store: any, getter: GetProvinciaGQL) => () =>
    runInInjectionContext(injector, () => {
      return getter
        .fetch(
          {},
          {
            context: { headers: { 'x-hasura-role': 'anonymous' } },
            fetchPolicy: 'cache-first',
          },
        )
        .pipe(
          tap(() => patchState(store, { loading: true })),
          tapResponse({
            next: (res) => {
              patchState(store, {
                loading: false,
                lista: res.data?.unita_amministrativa_provincia,
                failure: undefined,
              });
            },
            error: (error) => {
              patchState(store, {
                loading: false,
                failure: error,
              });
            },
          }),
        );
    });
